export default __webpack_public_path__ + "static/media/Tarim's Shield of Sanctity.792bcfc5.jpg";